// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3NUiL","title":"AfterFrontImage_title__EoELQ"};